module.exports = __webpack_public_path__ + "img/centre de thalasso.c5769bcf.png";